import {
  compose, reduce, add, values, map, prop,
} from 'ramda';

export const getTotalBet = compose(
  reduce(add, 0),
  map(prop('value')),
  values
);
